export class NumberUtils {
  public static roundToDecimalPlaces(input: number, decimalPlaces: number): number {
    return Math.round(input * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
  }

  /**
   * Change a number into a string with the given number of decimal places. e.g. (6, 2) => '6.00'
   * @param num Number to convert
   * @param decimalPlaces Number of decimal places to add if needed
   * @returns string
   */
  public static forceDecimal(num: number, decimalPlaces = 1): string {
    let str = `${num}`;
    if (!str.includes('.')) {
      let counter = 0;
      str = str + '.';
      while (counter < decimalPlaces) {
        str = str + '0';
        counter++;
      }
    }
    return str;
  }

  /**
   * Slice a decimal number to the given number of places. No rounding is done.
   * If number to return has trailing 0s, they are removed automatically
   * @param input The number to be sliced
   * @param decimalPlaces The number of decimal places to which it will be sliced
   * @returns The sliced number
   */
  public static sliceToDecimalPlaces(input: number, decimalPlaces: number): number {
    if (input == null) {
      return input;
    }
    const stringVal = input + '';
    return stringVal.split('.')[1]
      ? +`${stringVal.split('.')[0]}.${stringVal.split('.')[1].substr(0, decimalPlaces)}`
      : +stringVal;
  }

  /**
   * Recurse through an object and round all decimal numbers found to n decimal places
   * @param object The object to be recursed which potentially contains numbers to be rounded
   * @param n The number of decimal places to which the numbers will be rounded if longer than n
   * @returns
   */
  public static roundDecimalsInObjectRecursive(object: any, n: number) {
    if (typeof object !== 'object' || object == null) {
      return;
    }
    const keys = Object.keys(object);
    for (const key of keys) {
      if (
        typeof object[key] === 'number' &&
        (object[key] + '').split('.')[1] &&
        (object[key] + '').split('.')[1].length > n
      ) {
        object[key] = NumberUtils.roundToDecimalPlaces(object[key], n);
      } else {
        this.roundDecimalsInObjectRecursive(object[key], n);
      }
    }
    return object;
  }

  /**
   * Multiply every element of a 2-dimensional array of numbers by n
   * @param arr The 2-dimensional array
   * @param n The number to multiply each element by
   * @returns A new 2-dimensional array containing the new values
   */
  public static multiplyArrayByNumber2D(arr: Array<Array<number>>, n: number) {
    const toReturn = [];
    for (const list of arr) {
      const l = [];
      for (const value of list) {
        l.push(value * n);
      }
      toReturn.push(l);
    }
    return toReturn;
  }

  /**
   * Multiply every element of an array of numbers by n
   * @param arr The 1-dimensional array
   * @param n TGhe number to multiply each element by
   * @returns A new 1-dimensional array containing the new values
   */
  public static multiplyArrayByNumber1D(arr: Array<number>, n: number) {
    const toReturn = [];
    for (const value of arr) {
      toReturn.push(value * n);
    }
    return toReturn;
  }

  public static castStringToNumber(value: string): number | null {
    if (value == null || value === '') return null;
    const valueNumber = +value;
    if (isNaN(valueNumber)) {
      return null;
    } else if (typeof valueNumber === 'number') {
      return valueNumber;
    }
  }

  public static getOrdinalSuffix(n: number): 'st' | 'rd' | 'th' | 'nd' {
    return n % 10 === 1 && n !== 11 ? 'st' : (n % 10 === 2 && n !== 12 ? 'nd' : (n % 10 === 3 && n !== 13 ? 'rd' : 'th'));
  }
}
